import { render, staticRenderFns } from "./CartRu.vue?vue&type=template&id=1adfecc2&scoped=true&"
import script from "./CartRu.vue?vue&type=script&lang=js&"
export * from "./CartRu.vue?vue&type=script&lang=js&"
import style0 from "./CartRu.vue?vue&type=style&index=0&id=1adfecc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adfecc2",
  null
  
)

export default component.exports